export class VideoPlayer {
    private _rootEl: HTMLElement;
    private _videoEl: HTMLVideoElement;
    private _playButton: HTMLButtonElement;

    constructor(videoRootEl: HTMLElement) {
        this._rootEl = videoRootEl;
        this._videoEl = this._rootEl.querySelector("video");
        this._playButton = this._rootEl.querySelector(".js-video-play");

        this._playButton.addEventListener("click", () => {
            this._videoEl.play();
            this._videoEl.controls = true;

            this._rootEl.classList.add("ao-video--playing");
        });

        // this._videoEl.addEventListener("pause", () => {
        //     this._videoEl.controls = false;
        //
        //     this._rootEl.classList.remove("ao-video--playing");
        // });
    }
}